'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "httpClient", "type", "requireProtocol", "requireHttps", "validationMessage", "validateDefaultValue", "onSuccess", "onError"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import http from 'hub-http/clients/apiClient';
import * as UIValidatedFormControlPropsInterface from '../core/UIValidatedFormControl/UIValidatedFormControlPropsInterface';
import UIValidatedFormControl from 'ui-addon-form-validation/core/UIValidatedFormControl/UIValidatedFormControl';
import urlMessageDefaults from './urlMessageDefaults';
import { urlValidationTypes } from './urlValidationConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export default class UIValidatedUrlFormControl extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        httpClient,
        type,
        requireProtocol,
        requireHttps,
        validationMessage,
        validateDefaultValue,
        onSuccess,
        onError
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIValidatedFormControl, Object.assign({}, rest, {
      className: className,
      validator: "url",
      validationMessage: validationMessage,
      validateDefaultValue: validateDefaultValue,
      validationOpts: {
        type,
        httpClient,
        requireProtocol,
        requireHttps
      },
      onSuccess: onSuccess,
      onError: onError,
      children: children
    }));
  }
}
UIValidatedUrlFormControl.propTypes = Object.assign({}, UIValidatedFormControlPropsInterface.propTypes, {
  type: PropTypes.oneOf(Object.keys(urlValidationTypes)),
  httpClient: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  requireProtocol: PropTypes.bool,
  requireHttps: PropTypes.bool,
  value: PropTypes.string
});
UIValidatedUrlFormControl.defaultProps = Object.assign({}, UIValidatedFormControlPropsInterface.defaultProps, {
  httpClient: http,
  type: urlValidationTypes.basic,
  requireProtocol: false,
  requireHttps: false,
  validationMessage: urlMessageDefaults,
  validateDefaultValue: false
});